import classNames from 'classnames';
import React from 'react';
import { Offcanvas, Card, Image } from 'react-bootstrap';
import moment from 'moment';
const baseUrl = process.env.REACT_APP_API;

const CanvasTarea = ({ show, toggle, data }) => {
    // Formateo de fechas usando moment
    const formattedFechaTarea = moment(data.fecha_tarea).format('DD/MM/YYYY HH:mm');
    // const formattedDateStart = data.date_start ? moment(data.date_start).format('DD/MM/YYYY HH:mm') : 'N/A';
    // const formattedDateDone = data.date_done ? moment(data.date_done).format('DD/MM/YYYY HH:mm') : 'N/A';
    // const formattedDateRec = data.start_rec ? moment(data.start_rec).format('DD/MM/YYYY HH:mm') : 'N/A';
    // Parseo de fotos si es un string
    let fotosArray = [];
    if (data.fotos && typeof data.fotos === 'string') {
        try {
            fotosArray = JSON.parse(data.fotos);
        } catch (error) {
            console.error('Error al parsear fotos:', error);
        }
    }

    return (
        <Offcanvas show={show} onHide={toggle} scroll={true} backdrop={true}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>
                    <b className="mx-2 text-primary">Tarea</b>
                    <span
                        className={classNames('badge mx-2', {
                            'bg-primary': data.tipo_tarea === 'INSTALACION',
                            'bg-warning': data.tipo_tarea === 'TICKET',
                            'bg-danger': data.tipo_tarea === 'OTRO',
                        })}>
                        {data.tipo_tarea}
                    </span>
                    <span>ID: {data.id_tarea}</span>
                </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <p>
                    <strong>TAREA:</strong> {data.detalle_tarea}
                </p>
              
                <p>
                    <strong>Ayudantes:</strong> {data.ayudantes}
                </p>
                <p>
                    <strong>Lider:</strong> {data.lider}
                </p>
                <p>
                    <strong>Fecha Tarea:</strong> {formattedFechaTarea}
                </p>
                {/* <p>
                    <strong>Inicio:</strong> {formattedDateStart}
                </p>

                <p>
                    <strong>Finalización:</strong> {formattedDateDone}
                </p> */}
                <p>
                    <strong>Agente:</strong> {data.agente}
                </p>

                {fotosArray.length > 0 && (
                    <div>
                        <h5>Evidencia:</h5>
                        <div className="d-flex flex-wrap">
                            {fotosArray.map((foto, index) => (
                                <Image
                                    key={index}
                                    src={baseUrl + foto}
                                    alt={`Foto ${index + 1}`}
                                    thumbnail
                                    className="m-2"
                                    style={{ maxWidth: '150px', maxHeight: '150px' }}
                                />
                            ))}
                        </div>
                    </div>
                )}
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default CanvasTarea;
